module.exports = __webpack_public_path__ + "media/images/twitter-9507a17a.svg";